import React from 'react'
import { MdNavigateNext } from 'react-icons/md'

function ReadMoreIcon() {
  return (
    <>
    <MdNavigateNext size={25} className='readMoreIcon'/>
    </>
  )
}

export default ReadMoreIcon